import { createFileRoute } from "@tanstack/react-router"
import { ProcurementSettingsPage } from "~/components/settings/ProcurementSettingsPage"

export const Route = createFileRoute("/_auth/settings/_layout/procurement")({
  component: ProcurementSettingsPage,
})
